/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);

const $button      = $el.find('.mini-button');
const $description = $el.find('.card-description');
const $buttonTxt   = $button.find('span');

let expanded = false;

$button.on('click', function(e) {
    e.preventDefault();

    if (expanded) {
        $description.removeClass('expand');
        $buttonTxt.html('Expandir detalhes +');
    } else {
        $description.addClass('expand');
        $buttonTxt.html('Ocultar detalhes -');
    }

    expanded = !expanded;
});
